import { useCallback, useLayoutEffect, useRef } from "react";
import { brandPropTypes } from "app/utils/propTypes";
import PropTypes from "prop-types";
import "./Listing.scss";
import "src/app/pages/SmartDP/Search/SDPSearchForm/SmartDPSearchForm.scss";
import ListingHeaderContainer from "app/pages/Listing/ListingHeader/ListingHeaderContainer";
import { BRANDS } from "app/constants";
import { AsideProductFiltersContainer } from "app/pages/.shared/AsidePanel/AsideProductFilters/AsideProductFiltersContainer";
import { AsideProductFiltersMenu } from "@brand/AsidePanel/AsideProductFilters/AsideProductFiltersMenu";
import ProductsFilterContainer from "@brand/ProductsFilter/ProductsFilterContainer";
import { scrollToElement } from "app/utils/scroller";
import { forceCheck } from "react-lazyload";
import CookiePolicyFooterContainer from "app/pages/.shared/CookiePolicyFooter/CookiePolicyFooterContainer";
import ListingContentContainer from "app/pages/Listing/ListingContent/ListingContentContainer";
import { PushNotificationContainer } from "app/pages/.shared/PushNotification/PushNotificationContainer";
import PartnerSEO from "app/pages/.shared/PartnerSEO/PartnerSEO";
import ProductsFilter from "@brand/ProductsFilter/ProductsFilter";
import useOnSticky from "app/pages/.shared/useOnSticky";
import ListingHeadMetadata from "app/pages/Listing/ListingHeadMetadata";
import ScrollToTopButton from "app/pages/.shared/ScrollToTopButton/ScrollToTopButton";

const Listing = ({ brand, idSpotlight, displayProductsCount, listingSEO = {}, resolution }) => {
	const listingHeaderRef = useRef();
	const filtersRef = useRef();
	const isElementOnScreen = useOnSticky({ ref: filtersRef });

	const asideProductFiltersMenuComponent = useCallback(
		props => {
			return (
				(brand === BRANDS.AF || brand === BRANDS.TO || brand === BRANDS.UG) && (
					<AsideProductFiltersMenu
						scrollToListingHeader={scrollToListingHeader}
						{...props}
					/>
				)
			);
		},
		[brand]
	);

	useLayoutEffect(() => {
		// force l'affichage des images des produits sur mobile lorsqu'un filtre est actif
		forceCheck();
	}, []);

	const scrollToListingHeader = () => {
		scrollToElement({
			element: listingHeaderRef.current,
			offset: 0,
			disableSmoothScroll: true,
		});
	};

	return (
		<>
			<AsideProductFiltersContainer>
				<ProductsFilterContainer
					asideFilterMenu={false}
					renderComponent={asideProductFiltersMenuComponent}
				/>
			</AsideProductFiltersContainer>

			<div className="listing">
				<ListingHeadMetadata />
				<ListingHeaderContainer
					idSpotlight={idSpotlight}
					scrollToListingHeader={scrollToListingHeader}
					listingHeaderRef={listingHeaderRef}
					displayProductsCount={displayProductsCount}
				/>

				<ProductsFilterContainer
					scrollToListingHeader={scrollToListingHeader}
					renderComponent={props => (
						<ProductsFilter
							{...props}
							className="listing__filters"
							filtersRef={filtersRef}
							isStuck={isElementOnScreen}
							isSticky={true}
						/>
					)}
				/>

				<ListingContentContainer
					displayProductsCount={displayProductsCount}
					spotlightUri={idSpotlight}
				/>

				<PartnerSEO
					title={listingSEO.title}
					description={listingSEO.description}
					resolution={resolution}
				/>

				<ScrollToTopButton />

				<CookiePolicyFooterContainer />
			</div>
			<PushNotificationContainer />
		</>
	);
};

Listing.propTypes = {
	brand: brandPropTypes,
	idSpotlight: PropTypes.string,
	listingSEO: PropTypes.object,
	displayProductsCount: PropTypes.bool,
	resolution: PropTypes.string,
	resetAllSDPProductsFilter: PropTypes.func,
};

export default Listing;
